import { render, staticRenderFns } from "./TheDecimalInput.vue?vue&type=template&id=28417f55&"
import script from "./TheDecimalInput.vue?vue&type=script&lang=js&"
export * from "./TheDecimalInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheTinyInput: require('/web/components/TheTinyInput.vue').default})
